import { render } from "./App.vue?vue&type=template&id=ac36eb8c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/home/brandon/Code/Clients/PhilipComan/specialty-studio-vuetify-theme-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__